import React from 'react';
import SellStockSection from './SellStockSection';
import text from '../../assets/img/sell-cars-text.svg';
import rectangle from '../../assets/img/rect-buy.svg';
import notebookSellerSm from '../../assets/img/notebook-s-sm.svg';
import notebookSellerMd from '../../assets/img/notebook-s-md.svg';
import ss1 from '../../assets/img/icons/ss1.svg';
import ss2 from '../../assets/img/icons/ss2.svg';
import ss3 from '../../assets/img/icons/ss3.svg';
import ss4 from '../../assets/img/icons/ss4.svg';
import ornamentBuy from '../../assets/img/ornament-buy.svg';

const items = [
  {
    image: ss4,
    title: 'Easy to use platform',
    caption:
      'Simple to use, easy to navigate, and built to help you focus on selling and buying stock.',
    imageAlt: 'Thumb up icon',
  },
  {
    image: ss3,
    title: 'No nonsense logistics',
    caption:
      'Once your vehicle is sold, both you and the buyer get notified with contact details to arrange payment and collection.',
    imageAlt: 'Dart icon',
  },
  {
    image: ss2,
    title: 'Choose how you sell',
    caption:
      'With our platform, you’re in control. Set time limits, minimum prices, or enable ‘buy now’ to sell fast.',
    imageAlt: 'Hammer icon',
  },
  {
    image: ss1,
    title: 'Sellers fees made simple',
    caption:
      'Sellers only need to pay a one-off fee of £45 per listing. No hidden fees. Simple.',
    imageAlt: 'Recipe icon',
  },
];

function SellSection() {
  return (
    <section className="sell-section">
      <div className="sell-section-header" id="sell-car">
        <h2 className="sell-section-header__title">
          <span>SOLUTION</span>
          <span> FOR SELLERS</span>
        </h2>
        <img src={text} alt="Arrows" className="sell-section-header__text" />
        <p className="sell-section-header__subtitle">
          <span>The Stock Vault set out to make selling your vehicles</span>
          <span> quick & easy. That’s why we’ve built a streamlined platform.</span>
          <span>Ready to use.</span>
        </p>
      </div>
      <div className="sell-section__features">
        {items.map((item) => (
          <div className="sell-section__feature">
            <div className="sell-section__feature-box">
              <img
                className="sell-section__feature-box-icon"
                src={item.image}
                alt={item.imageAlt}
              />
            </div>
            <div className="sell-section__feature-content">
              <h4 className="sell-section__feature-title">{item.title}</h4>
              <span className="sell-section__feature-caption">{item.caption}</span>
            </div>
          </div>
        ))}
      </div>
      <div className="sell-stock-section-wrapper">
        <div className="sell-stock-section-wrapper__inner">
          <div className="sell-section__image-wrapper">
            <img
              className="buy-section__image buy-section__image--sm"
              src={notebookSellerSm}
              alt="Two notebooks which display web app"
            />
            <img
              className="buy-section__image buy-section__image--md"
              src={notebookSellerMd}
              alt="Notebook which display web app"
            />
          </div>
          <SellStockSection
            title={
              <>
                <span>Want to sell</span>
                <span> your stock</span>
                <span> too?</span>
              </>
            }
            subtitle="Sell your Franchised stock with ease and flexibility."
          />
        </div>
      </div>
      <img src={rectangle} alt="Rectangle" className="sell-section-image__rect" />
      <img src={ornamentBuy} alt="Arrows" className="sell-section-image__ornament" />
    </section>
  );
}

export default SellSection;
